// extracted by mini-css-extract-plugin
module.exports = {"largeBadge":"BetaBadge_largeBadge__2jqrc"};